import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ProjectSuggester, SelectedProject } from '../../edit/components/suggester/ProjectSuggester';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledProjectSuggesterProps extends LabelledProps {
  value: SelectedProject[];
  onChange: (refs: SelectedProject[]) => void;
  tooltip?: string;
  tooltipOptions?: any;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  multiple: boolean;
  border?: 'border-noround' | 'border-noround-right';
}

export const LabelledProjectSuggester = (props: LabelledProjectSuggesterProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <ProjectSuggester
        value={props.value}
        autoFocus={props.autoFocus}
        inputId={props.id}
        required={props.permissions?.required || props.required}
        disabled={disabled}
        multiple={props.multiple}
        validation={props.validation}
        border={props.border}
        onChange={props.onChange}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
